import MojitoCore from 'mojito/core';
import DataProvidersTypes from 'services/sports-content/content-provider/types.js';

const DataProvider = MojitoCore.Services.DataProvider;
const {
    EventTipsProvider: { COLLECTION_NAME },
} = DataProvidersTypes;

/**
 * Class offering the possibility to link to event tips.
 *
 * @class EventTipsProvider
 * @extends Mojito.Core.Services.DataProvider
 * @memberof Mojito.Services.SportsContent.DataProviders
 */
class EventTipsProvider extends DataProvider {
    init(languageCode) {
        super.addSimpleCollection(COLLECTION_NAME, languageCode);
    }

    subscribeToEntity(eventId, onUpdate) {
        return super.subscribeToEntity(eventId, onUpdate, COLLECTION_NAME);
    }
}

export default new EventTipsProvider();
